import React from 'react';
import { ApolloError } from '@apollo/client';
import { Box } from '@mui/material';

import { Page, useAppLayoutContextConsumer } from '@occc-app/design-system';
import { SegmentFragment } from '@occc/graphql';
import { useIsUserPermittedTo, Feature } from '@occc/utils-access-control';
import { CanEditFormFields } from '@occc-app/App/CanEditFormFieldsContext';

import EditSegmentModalContainer from './EditSegmentModalContainer';
import ShowSegmentConfiguration from './ShowSegmentConfiguration';

import SegmentMembershipAssignment from '../components/SegmentMembershipAssignment/SegmentMembershipAssignment';
import { getSegmentPageHeaderLinks } from '../utils';

type ShowSegmentProps = {
  loading: boolean;
  error?: ApolloError;
  segment: SegmentFragment | null;
  refetchSegments: () => void;
};

const ShowSegment = ({ loading, error, segment, refetchSegments }: ShowSegmentProps) => {
  const links = React.useMemo(() => getSegmentPageHeaderLinks(segment), [segment]);
  useAppLayoutContextConsumer(links);

  const isUserPermittedToEditSegment = useIsUserPermittedTo(Feature.SEGMENT_EDIT);

  return (
    <Page
      browserTabTitle='Segment'
      pageHeaderProps={{ title: 'Segment Details' }}
      containerProps={{ variant: 'md' }}
    >
      {/* This part should be refactored. */}
      {/* We have to split segment details view from segment details update modal form */}
      <EditSegmentModalContainer
        segment={segment}
        isUserPermittedToEditSegment={isUserPermittedToEditSegment}
      >
        <CanEditFormFields isEditable={isUserPermittedToEditSegment}>
          <ShowSegmentConfiguration loading={loading} error={error} segment={segment} disabled />
        </CanEditFormFields>
      </EditSegmentModalContainer>
      {isUserPermittedToEditSegment && (
        <Box mt={1}>
          <SegmentMembershipAssignment refetchSegments={refetchSegments} />
        </Box>
      )}
    </Page>
  );
};

export default ShowSegment;
